import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const SectionContainer = styled.section`
  width: 100%;
  padding: 4rem 0; 
  display: flex;
  justify-content: center;
`;

const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  background-color: #fff;
  max-width: 1200px;
  width: 100%;
  padding: 1.5rem 3rem; 
  gap: 3rem;

  @media (max-width: 900px) {
    flex-direction: column;
    padding: 2rem 1.5rem;
    gap: 2rem;
  }
`;

const ImageColumn = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const InfoColumn = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const ProductImage = styled.img`
  max-width: 420px; 
  width: 100%;
  height: auto;
`;

const Title = styled.h1`
  margin: 0 0 2rem 0;
  line-height: 1.2;
`;

const SubTitle = styled.span`
  display: block;
  font-size: 1.75rem;
  font-weight: 300;
  color: #6c757d;
`;

const MainTitle = styled.span`
  display: block;
  font-size: 2.75rem;
  font-weight: 700;
  color: #333;
`;

const ButtonLink = styled(Link)`
  display: block;
  background-color: #658C4A;
  color: #fff;
  padding: 1rem;
  margin-bottom: 1rem;
  text-align: center;
  text-decoration: none;
  font-size: 1rem;
  font-weight: 600;
  transition: background-color 0.2s ease-in-out;

  &:hover {
    background-color: #4A6537;
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

const TrangNhuaDieu = () => {
  const { t } = useTranslation();
  const { lang } = useParams<{ lang: string }>();
  const currentLang = lang || 'vi';

  return (
    <SectionContainer>
      <ContentWrapper>
        <ImageColumn>
          <ProductImage src="/images/tong-hop-nhua-dieu.png" alt={t('cashew_resin_page.image_alt')} />
        </ImageColumn>

        <InfoColumn>
          <Title>
            <SubTitle>{t('cashew_resin_page.subtitle')}</SubTitle>
            <MainTitle>{t('cashew_resin_page.main_title')}</MainTitle>
          </Title>

          <ButtonLink to={`/${currentLang}/products/ctg-01`}>{t('cashew_resin_page.view_ctg01_button')}</ButtonLink>
          <ButtonLink to={`/${currentLang}/products/ctg-02`}>{t('cashew_resin_page.view_ctg02_button')}</ButtonLink>
        </InfoColumn>
      </ContentWrapper>
    </SectionContainer>
  );
};

export default TrangNhuaDieu;